(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffc-student-discount"] && !window.DesignMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function(){
    console.log(`somethings`)
    element = document.querySelector('.ffc--student-discount--content-inner')
    console.log(element) 
}, false)
  

  } catch(e) { console.error(e); }
})();
})();
